export interface ComplianceAndAttendance{
    summaryComplianceAndAttendance:string;
}

export const defaultComplianceAndAttendance:ComplianceAndAttendance = {
    summaryComplianceAndAttendance:""
}